<script setup>
import { useCallWindowStore } from '@/stores/callWindow'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

const callWindowStore = useCallWindowStore()
const { isVisible } = storeToRefs(callWindowStore)

const handleMinimize = () => {
  callWindowStore.minimizeWindow()
}

const router = useRouter()
const goToNewTicket = () => {
  router.push('/new-ticket')
  callWindowStore.minimizeWindow()
}

// Mock data
const tags = [{ name: 'вредный', color: '#9F0000FF' }]

const accountDetails = {
  name: 'Звонилкин Надоед Клиентович',
  contact1: '+791183425462',
  contact2: 'Еще какая то инфа о контрагенте',
}

const tickets = [
  {
    id: 124,
    state: 'frozen',
    address: 'пр. Дружбы Народов 123, 34',
    time: '20.01.2025 12:00',
    desc: 'Наблюдается систематическое отсутствие освещения на лестничной площадке пятого подъезда. Все лампочки перегорели, что создает неудобства для жильцов и угрозу безопасности в темное время су...',
  },
  {
    id: 123,
    state: 'normal',
    address: 'пр. Дружбы Народов 123, 34',
    time: '21.03.2024 09:20',
    desc: 'Мусорные контейнеры на территории дома регулярно переполняются, что приводит к образованию стихийных свалок и неприятному запаху. Просим рассмотреть возможность установки дополнительных контейнеров ...',
  },
  {
    id: 125,
    state: 'overdue',
    address: 'ул. Пушкина 72, 234',
    time: '02.09.2023 10:34',
    desc: 'Лифт в нашем доме часто застревает между этажами, что создает дискомфорт и угрозу безопасности жильцов. Просим провести тщательную диагностику лифтового оборудования и устранить все неисправности.',
  },
  {
    id: 99,
    state: 'completed',
    address: 'ул. Пушкина 72, 234',
    time: '18.07.2023 16:45',
    desc: 'Детская площадка во дворе дома находится в аварийном состоянии. Качели сломаны, песочница загрязнена строительным мусором. Просим произвести капитальный ремонт игрового оборудования, засыпа...',
  },
  {
    id: 105,
    state: 'completed',
    address: 'ул. Пушкина 72, 234',
    time: '18.07.2023 16:45',
    desc: 'Детская площадка во дворе дома находится в аварийном состоянии. Качели сломаны, песочница загрязнена строительным мусором. Просим произвести капитальный ремонт игрового оборудования, засыпа...',
  },
]
</script>

<template>
  <v-dialog v-model="isVisible" max-width="1000px" height="850px">
    <template #default>
      <v-card :border="3" class="card-container">
        <v-card-title class="title-container" @click="handleMinimize">
          <div class="d-flex align-center ga-4">
            <v-icon size="24" color="white">mdi-phone-ring</v-icon>
            <span class="page-text-title">Входящий вызов (01:32)</span>
          </div>
          <v-icon size="24" color="white">mdi-window-minimize</v-icon>
        </v-card-title>
        <v-card-text>
          <div class="d-flex ga-4 mb-4">
            <user-avatar :avatarSize="128" :userAvatarUrl="'userAvatarUrl'"></user-avatar>
            <div>
              <v-row>
                <v-col class="">
                  <div class="d-flex ga-4 align-center">
                    <span class="group-title text-decoration-underline">
                      {{ accountDetails.name }}
                    </span>
                    <ticket-tags :tags="tags"></ticket-tags>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <div class="d-flex flex-row ga-6">
                    <icon-block icon="mdi-cellphone">
                      {{ accountDetails.contact1 }}
                    </icon-block>
                    <icon-block icon="mdi-cellphone">
                      {{ accountDetails.contact2 }}
                    </icon-block>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="details-container">
            <div class="details-container__finance">
              <simple-table class="mb-6"></simple-table>
            </div>
            <div class="details-container__tickets">
              <v-btn color="primary" @click="goToNewTicket">Создать новое обращение</v-btn>
              <div class="tickets-container mt-4">
                <v-virtual-scroll :items="tickets" :item-height="96">
                  <template v-slot="{ item }">
                    <div class="mb-4">
                      <ticket-desc :ticket="item"></ticket-desc>
                    </div>
                  </template>
                </v-virtual-scroll>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<style lang="scss" scoped>

.tickets-container {
  display: flex;
  flex-direction: column;
  height: 390px;
  overflow-y: auto;
}

.card-container {
  border-radius: 3px;
}

.v-dialog>.v-overlay__content>.v-card>.v-card-text {
  padding: 16px;
}

.group-title {
  font-size: 18px;
  line-height: 21px;
  font-weight: 500;
}

.title-container {
  background-color: rgb(var(--v-theme-brandPrimary));
  padding: 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  transition: opacity 0.3s ease;
  opacity: 1;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}

.page-text-title {
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  color: rgb(var(--v-theme-brandWhite));
}
</style>
